import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export function TemplateEditorModal({ isOpen, onClose, templateContent, onSave }) {
  const [content, setContent] = useState(templateContent);

  useEffect(() => {
    if (isOpen && templateContent) {
      setContent(templateContent);
    }
  }, [isOpen, templateContent]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg border border-border max-w-4xl w-full max-h-[85vh] flex flex-col">
        <div className="border-b border-border p-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Edit Template</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-background rounded-lg transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-text-muted" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full h-full min-h-[400px] px-4 py-3 bg-background border border-border rounded-lg text-foreground font-mono text-sm leading-relaxed resize-none focus:outline-none focus:ring-2 focus:ring-primary"
            placeholder="Template content..."
          />
        </div>

        <div className="border-t border-border p-4 flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-text-muted hover:text-foreground transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(content)}
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            Save Document
          </button>
        </div>
      </div>
    </div>
  );
}
